import { render } from "./PageNotFoundCustomer.vue?vue&type=template&id=64c17fa6"
const script = {}

import exportComponent from "/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__